import * as Yup from 'yup'

export const cashSchema = Yup.object().shape({
  newcash: Yup.number()
    .required('O valor é obrigatório')
    .transform((_, value) => +value.replace(/,/, '.'))
    .positive('O valor deve ser positivo'),
  qty: Yup.string().required('A quantidade é obrigatória'),
})
